import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { LeaderboardItemType } from "../components/Leaderboard/types";

export type PeriodType = "all_time" | "week" | "month";
type Params = {
	periodType: PeriodType;
	userId: number;
	projectId: number;
	organizationId: number;
};

export const fetchLeaderboardItems = async ({
	periodType,
	userId,
	projectId,
	organizationId,
}: Params): Promise<LeaderboardItemType[]> => {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/user-events/leaderboard-users-by-period`,
		{
			projectId,
			organizationId,
			periodType,
			limit: 10,
			userId,
		},
	);

	return data.data.leaderboard;
};

export const fetchUserRank = async ({
	userId,
	periodType,
	projectId,
	organizationId,
}: Params): Promise<LeaderboardItemType> => {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/user-events/get-user-rank-by-period`,
		{
			userId,
			projectId,
			organizationId,
			periodType,
		},
	);

	return data.data.leaderboardUserRecord;
};
